import Vue from 'vue';
import VueI18n from 'vue-i18n';
import messages from '@/translations';

// Add translation
Vue.use(VueI18n);
const i18n = new VueI18n({
  locale: JsPAPI?.api?.config?.locale ?? 'en',
  fallbackLocale: 'en',
  messages,
});

export default class Discovery {
  /**
   * Registers a Vue component
   * @param {*} component - the component name you want to mount
   * @param {*} target - the html element to mount to
   * @param {*} params - any props you want to pass on to the component at the root level
   * @returns Vue app instance
   */
  static vueLoader(component, target, params = {}) {
    Vue.prototype.JsPAPI = JsPAPI;
    const v = new Vue(
      {
        data() { return { params }; },
        render: (h) => h(Discovery.components[component]),
        i18n,
      },
    );
    v.$mount(target);
    return v;
  }

  /**
   * Prints formatted console msg if string, otherwise dumps object
   * @param data {String | Object} Output to be dumped
   */
  static log(data) {
    // eslint-disable-next-line no-console
    if (typeof data === 'string') console.log(`Discovery | ${data}`);
    // eslint-disable-next-line no-console
    else console.log(data);
  }
}
